export const SET_DADOS_CARRINHO = 'CARRINHO/SET_DADOS_CARRINHO'
export const LIMPAR_DADOS_CARRINHO = 'CARRINHO/LIMPAR_DADOS_CARRINHO'
export const SET_ADICIONAR_ITEM_CARRINHO = 'CARRINHO/SET_ADICIONAR_ITEM_CARRINHO'
export const SET_OBTER_VALOR_TOTAL_CARRINHO = 'CARRINHO/SET_OBTER_VALOR_TOTAL_CARRINHO'
export const REMOVER_ITEM_CARRINHO = 'CARRINHO/REMOVER_ITEM_CARRINHO'
export const AUMENTAR_QUANTIDADE_ITEM_CARRINHO = 'CARRINHO/AUMENTAR_QUANTIDADE_ITEM_CARRINHO'
export const DIMINUIR_QUANTIDADE_ITEM_CARRINHO = 'CARRINHO/DIMINUIR_QUANTIDADE_ITEM_CARRINHO'
export const SET_CUPOM_DATA_DO_CARRINHO = 'CARRINHO/SET_CUPOM_DATA_DO_CARRINHO'
